import { types, getRoot } from 'mobx-state-tree';
import { IRootStore } from 'store/root';

const _LocField = types
    .model('LocField', {
        data: types.optional(types.map(types.optional(types.string, '', [null])), {}, [null, undefined]),
    })
    .views((self) => {
        const views = {
            get root(): IRootStore {
                return getRoot<IRootStore>(self);
            },
            get systemInfo() {
                return views.root.systemInfo;
            },
            // return default langauge (en) except TW region
            get default() {
                const { defaultLocale } = views.systemInfo;
                return self.data.get(defaultLocale) || '';
            },
            // return current language setting version
            get value(): string {
                const { locale } = views.systemInfo;
                return self.data.get(locale) || views.default;
            },
        };
        return views;
    });

export const LocField = types.snapshotProcessor(_LocField, {
    preProcessor(sn: any) {
        if (sn && sn.data) return sn;
        return {
            data: sn,
        };
    },
});

const regexProductSelector = /\[([\d]+)\] (.*)$/;
const _ProductSelector = types.model('productSelector', {
    productId: types.optional(types.string, '', [null, undefined]),
    productName: types.optional(types.string, '', [null, undefined]),
});

export const ProductSelector = types.snapshotProcessor(_ProductSelector, {
    preProcessor(sn: any) {
        const results = regexProductSelector.exec(sn || '');
        if (!results) return {};

        return {
            productId: results[1],
            productName: results[2],
        };
    },
});
